import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const NODE_ENV = import.meta.env.MODE;

const VITE_DATADOG_APPLICATION_ID = import.meta.env.VITE_DATADOG_APPLICATION_ID;
const VITE_DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
const VITE_DATADOG_SITE = import.meta.env.VITE_DATADOG_SITE;
const VITE_DATADOG_SERVICE_NAME = import.meta.env.VITE_DATADOG_SERVICE_NAME;

// NOTE: Datadog should run on our QA / STAGE env as well, for now
const DATADOG_ENABLED = NODE_ENV !== 'development'
  && VITE_DATADOG_APPLICATION_ID
  && VITE_DATADOG_CLIENT_TOKEN
  && VITE_DATADOG_SITE
  && VITE_DATADOG_SERVICE_NAME;

let isInitialized = false;

export const initializeDataDog = () => {
  if (isInitialized) return;

  isInitialized = true;

  DATADOG_ENABLED && datadogRum.init({
    applicationId: VITE_DATADOG_APPLICATION_ID,
    clientToken: VITE_DATADOG_CLIENT_TOKEN,
    site: VITE_DATADOG_SITE,
    service: VITE_DATADOG_SERVICE_NAME,
    env: NODE_ENV,
    version: window.__TAG_VERSION,
    sessionSampleRate: 1,
    sessionReplaySampleRate: 1,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      /https:\/\/.*\.livetables.io/,
      /https:\/\/.*\.devezugi.com/,
      /https:\/\/.*\.cdnees.com/,
      /https:\/\/.*\.thefunlink.com/,
      /https:\/\/.*\.thefun.space/,
      /https:\/\/.*\.livetablesnj.com/,
      /https:\/\/.*\.livetablesmi.com/,
      /https:\/\/.*\.livetablespa.com/,
    ],
  });

  DATADOG_ENABLED && datadogLogs.init({
    clientToken: VITE_DATADOG_CLIENT_TOKEN,
    service: VITE_DATADOG_SERVICE_NAME,
    site: VITE_DATADOG_SITE,
    env: NODE_ENV,
    version: window.__TAG_VERSION,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
};
